export const GA_MEASUREMENT_ID = "G-PEDF4C8K1S"
export const ADS_CONVERSION_ID = "AW-1051216162"

export const CONVERSION_LABELS = {
  VIEW_CONTACT_PAGE: "dtdQCNyT9rYaEKKSofUD",
  BUY_NOW_COMPLETION: "9oFECIP29LYaEKKSofUD",
  SUBMIT_CONTACT_FORM: "NqHhCNmT9rYaEKKSofUD",
  INQUIRY_SUBMIT: "uVQsCJ6U9bYaEKKSofUD",
  VIEW_VEHICLE: "1izkCNjy9rYaEKKSofUD",
  CLICK_TO_CALL: "Fb-fCJPRlu4bEKKSofUD",
  CLICK_TO_WHATSAPP: "cEbYCJbRlu4bEKKSofUD",
}

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void
  }
}

export function pageview(url: string) {
  if (typeof window.gtag !== "undefined") {
    window.gtag("config", GA_MEASUREMENT_ID, {
      page_path: url,
    })
  }
}

export function event(action: string, params?: Record<string, unknown>) {
  if (typeof window.gtag !== "undefined") {
    window.gtag("event", action, params)
  }
}

export function trackConversion(label: string, params?: Record<string, unknown>) {
  if (typeof window.gtag !== "undefined") {
    window.gtag("event", "conversion", {
      send_to: `${ADS_CONVERSION_ID}/${label}`,
      ...params,
    })
  }
}

export function trackViewVehicle(vehicleSlug: string) {
  trackConversion(CONVERSION_LABELS.VIEW_VEHICLE)
  event("view_item", { item_id: vehicleSlug })
}

export function trackViewContactPage() {
  trackConversion(CONVERSION_LABELS.VIEW_CONTACT_PAGE)
}

export function trackBuyNowCompletion(transactionId: string) {
  trackConversion(CONVERSION_LABELS.BUY_NOW_COMPLETION, {
    transaction_id: transactionId,
  })
  event("purchase", { transaction_id: transactionId })
}

export function trackContactFormSubmit() {
  trackConversion(CONVERSION_LABELS.SUBMIT_CONTACT_FORM)
  event("generate_lead", { event_category: "contact" })
}

export function trackInquirySubmit(vehicleSlug?: string) {
  trackConversion(CONVERSION_LABELS.INQUIRY_SUBMIT)
  event("generate_lead", { event_category: "inquiry", item_id: vehicleSlug })
}

export function trackClickToCall(phoneNumber?: string) {
  trackConversion(CONVERSION_LABELS.CLICK_TO_CALL, { value: 1.0, currency: "USD" })
  event("click_to_call", { event_category: "contact", phone_number: phoneNumber })
}

export function trackClickToWhatsApp(phoneNumber?: string) {
  trackConversion(CONVERSION_LABELS.CLICK_TO_WHATSAPP)
  event("click_to_whatsapp", { event_category: "contact", phone_number: phoneNumber })
}
